<div
  class="tag-add-wrapper"
  dropdown
  container="body"
  #dropdown="bs-dropdown"
  [insideClick]="true"
  [autoClose]="autoClose"
>
  @if (icon != null) {
    <div dropdownToggle>
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </div>
  }
  @if (icon == null) {
    <div class="tag-add" tooltip="Add tag" dropdownToggle>
      <i class="feather plus"></i>
    </div>
  }
  <div
    id="dropdown-triggers-manual"
    *dropdownMenu
    class="dropdown-menu tag-add-dropdown-menu"
    role="menu"
    aria-labelledby="button-triggers-manual"
    (click)="$event.stopPropagation()"
  >
    <!-- $event.stopPropagation to prevent closing on tag click -->
    <input
      type="text"
      class="form-control"
      placeholder="Search tags"
      [(ngModel)]="search"
      (keyup)="filterSearchTags()"
    />
    <hr />
    <div class="tag-search-list">
      @for (tag of tags; track tag.uuid) {
        <ch-tag
          [name]="tag.name"
          [color]="tag.color"
          (click)="_tagClick(tag)"
          [canRemove]="false"
        ></ch-tag>
      } @empty {
        @if (search == "") {
          <div class="empty">No tags found</div>
        }
        @if (search != "") {
          <div class="empty">No tags found for "{{ search }}"</div>
        }
      }
    </div>
    <hr />
    <!-- <div class="form-group or-and-switch align-items-center">
      <div class="switch-toggle">
        <div class="toggle-wrapper">
          <div class="toggle">
            <input
              type="checkbox"
              name="andor"
              (change)="switchToggle()"
              [checked]="andOrFilter == 'and'"
              class="check"
            />
            <b class="b switch"></b>
            <b class="b track"></b>
          </div>
        </div>
      </div>
      <label>ANY/ALL</label>
    </div> -->
    <div class="form-group or-and-switch align-items-center">
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="andOrNotFilter"
          id="anyRadio"
          value="or"
          [checked]="andOrFilter === 'or'"
          (change)="setFilter('or')"
        />
        <label class="form-check-label" for="anyRadio">ANY</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="andOrNotFilter"
          id="allRadio"
          value="and"
          [checked]="andOrFilter === 'and'"
          (change)="setFilter('and')"
        />
        <label class="form-check-label" for="allRadio">ALL</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="andOrNotFilter"
          id="notRadio"
          value="not"
          [checked]="andOrFilter === 'not'"
          (change)="setFilter('not')"
        />
        <label class="form-check-label" for="notRadio">NOT</label>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="extension"> </ng-container>
  </div>
</div>
